const WHEEL_RADIUS = 0.52;
const TYRE_WIDTH = 0.295;
const DUAL_SPACING = 0.36;
const DUAL_HALF_TRACK = 0.9;
const STEER_HALF_TRACK = 1.02;
const DRUM_RAKE = -15 * Math.PI / 180;
const axleHalfTrack = (d, axle) => {
  var _a;
  return (_a = axle.halfTrack) != null ? _a : axle.fitment === "dual" ? d.dualHalfTrack : d.steerHalfTrack;
};
const lastAxle = (d) => {
  var _a;
  return (_a = d.axles[d.axles.length - 1]) != null ? _a : d.axles[0];
};
const MIXER_10 = {
  length: 8.8,
  cabWidth: 2.34,
  cabLength: 2.15,
  cabFloorY: 0.88,
  cabRoofY: 2.95,
  chassisY: 1.22,
  wheelRadius: WHEEL_RADIUS,
  tyreWidth: TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 2.95 },
    { fitment: "dual", x: -1.2 },
    { fitment: "dual", x: -2.55 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: [2.4, 1.1, -0.2, -1.5, -2.8],
  drum: {
    centreX: -0.55,
    centreY: 2.15,
    length: 4.6,
    midRadius: 1.18,
    frontRadius: 0.72,
    rearRadius: 0.62,
    rake: DRUM_RAKE
  }
};
const MIXER_6 = {
  length: 7.4,
  cabWidth: 2.32,
  cabLength: 2.05,
  cabFloorY: 0.86,
  cabRoofY: 2.8,
  chassisY: 1.18,
  wheelRadius: WHEEL_RADIUS,
  tyreWidth: TYRE_WIDTH,
  axles: [
    { fitment: "single", x: 2.35 },
    { fitment: "dual", x: -2.05 }
  ],
  steerHalfTrack: STEER_HALF_TRACK,
  dualHalfTrack: DUAL_HALF_TRACK,
  dualSpacing: DUAL_SPACING,
  crossmemberX: [1.6, 0.3, -1, -2.3],
  drum: {
    centreX: -0.7,
    centreY: 2.05,
    length: 3.8,
    midRadius: 1.08,
    frontRadius: 0.66,
    rearRadius: 0.56,
    rake: DRUM_RAKE
  }
};
export {
  MIXER_10,
  MIXER_6,
  axleHalfTrack,
  lastAxle
};
